import React, { useEffect, useState } from "react";
import { TitleBar } from "../../../Components/Common/TitleBar/titleBar";
import "./style/index.scss";
import {
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Table,
  Spinner,
  Toast,
  ToastHeader,
  ToastBody,
  Button,
  Row,
} from "reactstrap";
import { Pagination } from "../../../Components/Common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTrips,
  getAllDriverList,
  getAllTripsList,
  getAllVehicleList,
  getTripsById,
} from "../.../../../../slices/thunks";
import { TripModal } from "../../../Components/Common/TripModal/tripModal";
import moment from "moment/moment";
import { AssignTripmodal } from "../TripsModals/assignTrips";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { AddTripsModal } from "../TripsModals/addTripModal";
import { UploadTripModal } from "../TripsModals/UploadTripModal";
import {
  hideErrorMessage,
  setLoading,
} from "../../../slices/tripsDetails/reducer";
import DatePicker from "react-datepicker";
import Calender from "./calender";
import "react-datepicker/dist/react-datepicker.css";

const TripList = () => {
  const dispatch = useDispatch();

  const tripsList = useSelector((state) => state.Trips.tripsList);

  const loading = useSelector((state) => state.Trips.loading);
  const tripsById = useSelector((state) => state.Trips.tripsById);

  const driverList = useSelector(
    (state) => state.DriverManagementSlice.driverList
  );

  const vehicleList = useSelector((state) => state.Vehicle.vehicleList);
  const [selectedItem, setSelectedItem] = useState("All");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addTripModal, setAddTripModal] = useState(false);
  const [uploadTripModal, setUploadTripModal] = useState(false);
  const [deletTripModal, setDeletTripModal] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [isTimeFilterActive, setIsTimeFilterActive] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toasterType, setToasterType] = useState("success");
  const [toastMessage, setToastMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [viewDetails, setViewDetails] = useState(false);

  const options = ["All", "Today", "Yesterday", "Tomorrow"];

  const showToaster = (isSuccess, message) => {
    setShowToast(true);
    setToasterType(isSuccess ? "success" : "danger");
    setToastMessage(message);
    setTimeout(() => {
      setShowToast(false);
      if (!isSuccess) {
        dispatch(hideErrorMessage());
      }
    }, 3000);
  };

  const toggleModal = async () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleAddTripModal = async () => {
    setAddTripModal(!addTripModal);
  };

  const toggleViewDetailModal = async () => {
    setViewDetails(!viewDetails);
  };
  const toggleDeleteTripModal = () => {
    setDeletTripModal(!deletTripModal);
  };

  const toggleUploadTripModal = () => {
    setUploadTripModal(!uploadTripModal);
  };

  const handleDeleteModal = async () => {
    try {
      const response = await dispatch(deleteTrips(tripsById.id));
      const { success: isSuccess, message } = response;
      showToaster(isSuccess, message);
    } catch (error) {
      showToaster(false, error.message || "An unexpected error occurred");
    } finally {
      toggleDeleteTripModal();
      dispatch(
        getAllTripsList(
          currentPage,
          pageSize,
          searchText,
          selectedItem.toLowerCase(),
          "",
          ""
        )
      );
    }
  };

  useEffect(() => {
    try {
      if (loading.read) return;

      const delayDebounceFn = setTimeout(() => {
        const from = isTimeFilterActive
          ? moment(fromDate).format("YYYY-MM-DDTHH:mm:ss")
          : "";
        const to = isTimeFilterActive
          ? moment(toDate).format("YYYY-MM-DDTHH:mm:ss")
          : "";
        if (isTimeFilterActive) {
          dispatch(
            getAllTripsList(currentPage, pageSize, searchText, "", from, to)
          );
        } else if (selectedItem !== "All") {
          console.log("selectedItem", selectedItem.toLowerCase());

          dispatch(
            getAllTripsList(
              currentPage,
              pageSize,
              searchText,
              selectedItem.toLowerCase(),
              "",
              ""
            )
          );
        } else if (selectedItem !== "All") {
          console.log("selectedItem", selectedItem.toLowerCase());

          dispatch(
            getAllTripsList(currentPage, pageSize, searchText, "", "", "")
          );
        } else {
          dispatch(
            getAllTripsList(currentPage, pageSize, searchText, "", "", "")
          );
        }
        dispatch(getAllDriverList("", "", "", "", "", ""));
        dispatch(getAllVehicleList("", "", "", "", "", ""));
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    } catch (error) {}
  }, [
    currentPage,
    pageSize,
    searchText,
    selectedItem,
    fromDate,
    toDate,
    isTimeFilterActive,
  ]);

  document.title = "Trip List | D&A";

  const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
      type="button"
      onClick={onClick}
      ref={ref}
      className="custom-date-input"
    >
      <Calender />
      <span>{value}</span>
    </button>
  ));
  CustomDateInput.displayName = "CustomDateInput";

  const handleSelect = (option) => {
    setSelectedItem(option);
    setShowDropdown(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-lg-4 gap-2">
            <TitleBar title={"List of confirmed trips"} />

            <div
              className="position-fixed top-0 end-0 p-3"
              style={{ zIndex: 1055 }}
            >
              <Toast isOpen={showToast}>
                <ToastHeader
                  icon={toasterType === "danger" ? "danger" : "success"}
                  toggle={() => setShowToast(false)}
                >
                  {toasterType === "danger" ? "Error" : "Success"}
                </ToastHeader>
                <ToastBody>{toastMessage}</ToastBody>
              </Toast>
            </div>

            <div className="trip-header d-flex align-items-lg-center align-items-start justify-content-between">
              <div className="d-flex flex-column flex-lg-row align-items-lg-center align-items-start gap-lg-3 gap-2">
                <div className="relative dropdown-container">
                  <div
                    onClick={() => setShowDropdown(!showDropdown)}
                    className="dropdown-toggle"
                  >
                    <span>{selectedItem}</span>
                    <div className="dropdown-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="dropdown-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </div>
                  </div>
                  {showDropdown && (
                    <div className="absolute z-10 w-full bg-white border border-gray-300 rounded shadow">
                      <ul
                        className="dropdown-menu show"
                        style={{ minWidth: "200px" }}
                      >
                        {options.map((option) => (
                          <li
                            key={option}
                            onClick={() => handleSelect(option)}
                            className={`dropdown-item d-flex align-items-center ${
                              selectedItem === option ? "active" : ""
                            }`}
                          >
                            <input
                              className="form-check-input me-2"
                              type="radio"
                              readOnly
                              checked={selectedItem === option}
                            />
                            {option}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                <div className="d-flex align-items-lg-center align-items-start gap-3">
                  <div className="d-flex flex-column flex-lg-row align-items-lg-center align-items-start gap-2">
                    <label className="date-picker-label">From Time</label>
                    <DatePicker
                      selected={fromDate}
                      popperPlacement="top-end"
                      onChange={(date) => {
                        setFromDate(date);
                        setIsTimeFilterActive(true);
                      }}
                      showTimeSelect
                      dateFormat="MMM dd, yyyy hh:mm aa"
                      customInput={<CustomDateInput />}
                    />
                  </div>

                  <div className="d-flex flex-column flex-lg-row align-items-lg-center align-items-start gap-2">
                    <label className="date-picker-label">To Time</label>
                    <DatePicker
                      selected={toDate}
                      popperPlacement="top-end"
                      onChange={(date) => {
                        setToDate(date);
                        setIsTimeFilterActive(true);
                      }}
                      showTimeSelect
                      dateFormat="MMM dd, yyyy hh:mm aa"
                      customInput={<CustomDateInput />}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row-reverse flex-lg-row justify-content-end align-items-end p-0 gap-1 gap-lg-0">
                <InputGroup
                  className="search-input"
                  style={{ marginRight: "10px" }}
                >
                  <InputGroupText>
                    <i className="ri-search-line" />
                  </InputGroupText>
                  <Input
                    type="text"
                    placeholder="Search input text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        dispatch(getAllTripsList(1, pageSize, searchText));
                        setCurrentPage(1);
                      }
                    }}
                  />
                </InputGroup>
                <div className="d-flex gap-2">
                  <Button
                    className="uploadBtn d-flex gap-1"
                    onClick={() => {
                      dispatch(setLoading({ type: "read", value: false }));
                      toggleUploadTripModal();
                      setIsAdd(false);
                    }}
                  >
                    <span className="d-none d-md-flex"> Upload File </span>
                    <i className="ri-upload-2-line" />
                  </Button>
                  <Button
                    onClick={() => {
                      dispatch(setLoading({ type: "read", value: false }));
                      toggleAddTripModal();
                      setIsAdd(true);
                    }}
                    className="newJourneyBtn d-flex gap-1"
                  >
                    <span className="d-none d-md-flex"> New Journey</span>
                    <i className="ri-add-line" />
                  </Button>
                </div>
              </div>
            </div>
            <div className="trip-table">
              <Table hover>
                <thead>
                  <tr>
                    <th>Trip ID</th>
                    <th>Customer</th>
                    <th>Driver name</th>
                    <th>Start Location</th>
                    <th>End Location</th>
                    <th>Distance</th>
                    <th>Vehicle</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>

                {loading.read ? (
                  <tbody>
                    <tr>
                      <td colSpan="12" className="text-center align-middle">
                        <Spinner color="primary" />
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {tripsList?.results?.length > 0 ? (
                      tripsList?.results?.map((trip, index) => (
                        <tr key={index}>
                          <td>{trip.trip_id || "-"}</td>
                          <td>{trip.customer || "-"}</td>
                          <td>
                            {trip.drivers && trip.drivers.length > 0
                              ? trip.drivers.map((driver, index) => (
                                  <div key={index}>
                                    <ul>
                                      <li>
                                        {driver.first_name} {driver.last_name}
                                      </li>
                                    </ul>
                                  </div>
                                ))
                              : "-"}
                          </td>

                          <td>{trip.start_location || "-"}</td>
                          <td>{trip.end_location || "-"}</td>
                          <td>
                            {trip.distance || "-"} <br />
                            <span>
                              {trip?.hours_calculated}{" "}
                              {trip?.hours_calculated
                                ? trip?.hours_calculated > 1
                                  ? "hours"
                                  : "hour"
                                : ""}
                            </span>
                          </td>
                          <td>{trip.vehicle?.number_plate}</td>

                          <td>
                            {moment(
                              `${trip?.start_date} ${trip?.start_time}`,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("ddd, MMM D YYYY, hh:mm a")}
                          </td>
                          <td>
                            {moment(
                              `${trip?.end_date} ${trip?.end_time}`,
                              "YYYY-MM-DD HH:mm:ss"
                            ).format("ddd, MMM D YYYY, hh:mm a")}
                          </td>
                          <td>{trip.price || "-"}</td>
                          <td>
                            <div className="action-icons">
                              <i
                                className="ri-user-add-fill icon"
                                style={{ color: "#007AFF" }}
                                onClick={() => {
                                  dispatch(
                                    setLoading({ type: "read", value: false })
                                  );
                                  dispatch(getTripsById(trip.id));
                                  toggleModal();
                                }}
                              />
                              <i
                                className="ri-eye-fill icon"
                                style={{ color: "#E8A014" }}
                                onClick={() => {
                                  dispatch(
                                    setLoading({ type: "read", value: false })
                                  );
                                  dispatch(getTripsById(trip.id));
                                  toggleViewDetailModal();
                                }}
                              />
                              <i
                                className="ri-pencil-fill icon"
                                style={{ color: "#007AFF" }}
                                onClick={() => {
                                  dispatch(
                                    setLoading({ type: "read", value: false })
                                  );
                                  dispatch(getTripsById(trip.id));
                                  setIsAdd(false);
                                  toggleAddTripModal();
                                }}
                              />
                              <i
                                className="ri-delete-bin-fill icon"
                                style={{ color: "#FB0000" }}
                                onClick={() => {
                                  dispatch(
                                    setLoading({ type: "read", value: false })
                                  );
                                  dispatch(getTripsById(trip.id));
                                  toggleDeleteTripModal();
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-start text-sm-center" colSpan={12}>
                          <h3>No Trips Found</h3>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </Table>
            </div>
            {tripsList?.results?.length > 0 && (
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalItems={tripsList?.count || 0}
              />
            )}
          </div>

          <AssignTripmodal
            tripsById={tripsById}
            isModalOpen={isModalOpen}
            toggleModal={toggleModal}
            loading={loading.assign}
            currentPage={currentPage}
            pageSize={pageSize}
            searchText={searchText}
            selectedItem={selectedItem}
          />

          <AddTripsModal
            tripsById={tripsById}
            isAdd={isAdd}
            addTripModal={addTripModal}
            toggleAddTripModal={toggleAddTripModal}
            loading={isAdd ? loading.create : loading.update}
            currentPage={currentPage}
            pageSize={pageSize}
            searchText={searchText}
            selectedItem={selectedItem}
          />

          <UploadTripModal
            isAdd={isAdd}
            addTripModal={uploadTripModal}
            toggleAddTripModal={toggleUploadTripModal}
            loading={loading.create}
            currentPage={currentPage}
            pageSize={pageSize}
            searchText={searchText}
            selectedItem={selectedItem}
          />

          <DeleteModal
            show={deletTripModal}
            loading={loading.delete}
            onDeleteClick={() => {
              handleDeleteModal();
            }}
            onCloseClick={toggleDeleteTripModal}
          />

          <TripModal
            isModalOpen={viewDetails}
            toggleModal={toggleViewDetailModal}
            buttonText="Assign"
            closeText={"Close without saving"}
            title={"Trip Details"}
            tripText={"Trip Details"}
            showButtons={false}
            showDeleteIcon={false}
            showEditIcon={false}
            showcloseIcon={true}
            size="md"
          >
            <div className="px-3 d-flex flex-column gap-4">
              <Row className="mb-5">
                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Trip Id</span>
                    <span className="userDetailValue">
                      {" "}
                      {tripsById?.trip_id || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Customer</span>
                    <span className="userDetailValue">
                      {" "}
                      {tripsById?.customer || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Driver's</span>
                    <span className="userDetailValue">
                      {tripsById?.drivers && tripsById.drivers.length > 0
                        ? tripsById.drivers
                            .map((driverId) => {
                              const driver = driverList.find(
                                (d) => d.id === driverId
                              );
                              return (
                                driver &&
                                `${driver.first_name} ${driver.last_name}`
                              );
                            })
                            .join(", ")
                        : "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Start Location</span>
                    <span className="userDetailValue h-25">
                      {tripsById?.start_location || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">End Location</span>
                    <span className="userDetailValue h-25">
                      {tripsById?.end_location || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Distance (km)</span>
                    <span className="userDetailValue">
                      {tripsById?.distance_km || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Vehicle</span>

                    <span className="userDetailValue">
                      {(vehicleList.length > 0 &&
                        vehicleList.find((v) => v.id === tripsById?.vehicle)
                          ?.number_plate) ||
                        "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Half</span>
                    <span className="userDetailValue">
                      {tripsById?.half || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Price (km)</span>
                    <span className="userDetailValue">
                      {tripsById?.price_per_km || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Duration (hours)</span>
                    <span className="userDetailValue">
                      {" "}
                      {tripsById?.duration_hours || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Start Time</span>
                    <span className="userDetailValue">
                      {moment(
                        `${tripsById?.start_date} ${tripsById?.start_time}`,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("ddd, MMM D YYYY, hh:mm a") || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">End Time</span>
                    <span className="userDetailValue">
                      {moment(
                        `${tripsById?.end_date} ${tripsById?.end_time}`,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("ddd, MMM D YYYY, hh:mm a") || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Invoice Reference</span>
                    <span className="userDetailValue">
                      {tripsById?.invoice_reference || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Invoice</span>
                    <span className="userDetailValue">
                      {tripsById?.invoice || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">Notes</span>
                    <span className="userDetailValue">
                      {tripsById?.notes || "-"}
                    </span>
                  </div>
                </div>

                <div className="custom-box-value pb-0 border-bottom-0">
                  <div className="d-flex flex-column flex-md-row items-center justify-space-between gap-1 gap-md-3">
                    <span className="userDetailLabel">State</span>
                    <span className="userDetailValue">
                      <span
                        style={{
                          display: "inline-block",
                          width: "80px",
                          textAlign: "center",
                          backgroundColor:
                            tripsById?.state === "CURRENT"
                              ? "#28a74533"
                              : tripsById?.state === "NEXT"
                              ? "#ffc10733"
                              : tripsById?.state === "COMPLETED"
                              ? "#17a2b833"
                              : "#dc354533",
                          padding: "4px 8px",
                          borderRadius: "10px",
                          color:
                            tripsById?.state === "CURRENT"
                              ? "#28a745"
                              : tripsById?.state === "NEXT"
                              ? "#ffc107"
                              : tripsById?.state === "COMPLETED"
                              ? "#17a2b8"
                              : "#dc3545",
                          fontWeight: 500,
                        }}
                      >
                        {tripsById?.state === "CURRENT"
                          ? "Current"
                          : tripsById?.state === "NEXT"
                          ? "Next"
                          : tripsById?.state === "COMPLETED"
                          ? "Completed"
                          : "Inactive"}
                      </span>
                    </span>
                  </div>
                </div>
              </Row>
            </div>
          </TripModal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TripList;
